var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/css/styles.css": "034b",
	"./assets/img/big-data.png": "1bbe",
	"./assets/img/energy.png": "6ebc",
	"./assets/img/head-img.png": "2b4e",
	"./assets/img/head-news.png": "23e9",
	"./assets/img/icons/icon-brain.png": "e742",
	"./assets/img/icons/icon-car.png": "cb2c",
	"./assets/img/icons/icon-chip.png": "d718",
	"./assets/img/icons/icon-gis.png": "ccea",
	"./assets/img/icons/icon-iot.png": "46ff",
	"./assets/img/icons/icon-ra.png": "f674",
	"./assets/img/icons/icon-w3c.png": "50db",
	"./assets/img/icons/icon-world.png": "8156",
	"./assets/img/icons/iocn-block.png": "bf35",
	"./assets/img/industry.png": "af95",
	"./assets/img/logo-ict.png": "a9b4",
	"./assets/img/logo-part01.png": "f5bd",
	"./assets/img/logo-part02.png": "6400",
	"./assets/img/logo-part03.png": "a93d",
	"./assets/img/logos/ADB.png": "1c6e",
	"./assets/img/logos/BADD.png": "0371",
	"./assets/img/logos/BCIE.png": "d51a",
	"./assets/img/logos/BEI.png": "30cf",
	"./assets/img/logos/BID.png": "87eb",
	"./assets/img/logos/BM.png": "0010",
	"./assets/img/logos/CAF.png": "9a01",
	"./assets/img/logos/EB.png": "e206",
	"./assets/img/logos/NNUU.png": "594a",
	"./assets/img/logos/UE.png": "e45e",
	"./assets/img/logos/clustertic.svg": "eba6",
	"./assets/img/logos/izertis.png": "bfe1",
	"./assets/img/logos/sadim.jpg": "692b",
	"./assets/img/logos/simbiosys.png": "551a",
	"./assets/img/logos/veratia.png": "7c0c",
	"./assets/img/maps/izertis-map.png": "2d11",
	"./assets/img/maps/sadim-map.png": "4527",
	"./assets/img/maps/simbiosys-map.png": "9713",
	"./assets/img/maps/veratia-map.png": "b5af",
	"./assets/img/news/IV-encuentros-internacionales-sector-TIC.jpg": "b887",
	"./assets/img/news/Smart-Cities-and-Communities.png": "3f6b",
	"./assets/img/news/new-01.jpg": "5f3f",
	"./assets/img/news/pamm.jpg": "543b",
	"./assets/img/news/piwas.jpg": "0587",
	"./assets/img/partners/cluster/cluster-logo.svg": "f3a0",
	"./assets/img/partners/izertis/izertis-logo.png": "5823",
	"./assets/img/partners/sadim/sadim-logo.png": "637e",
	"./assets/img/partners/simbiosys/simbiosys-logo.png": "2ff3",
	"./assets/img/partners/veratia/veratia-logo.png": "fd1e",
	"./assets/img/planet.png": "f8c4",
	"./assets/img/poi-blue.png": "d563",
	"./assets/img/poi-red.png": "0b09",
	"./assets/img/presencia-internacional.png": "801d",
	"./assets/img/project-1.png": "4945",
	"./assets/img/project-2.png": "4fe4",
	"./assets/img/project-3.png": "70d6",
	"./assets/img/projects/web-foundation.jpg": "e6ff",
	"./assets/img/public-sector.png": "16d9",
	"./assets/img/service-design.png": "ab16",
	"./assets/img/services.png": "f490",
	"./assets/img/white-bottom-right.png": "54c8",
	"./assets/img/white-left-top.png": "ce6e",
	"./assets/img/white-right-bottom.png": "03ef",
	"./assets/img/white-top-center.png": "fd87",
	"./assets/img/white-top-left.png": "c21e",
	"./assets/logo.png": "cf05",
	"./components/Experience": "61cd",
	"./components/Experience.vue": "61cd",
	"./components/Experiences": "e44e",
	"./components/Experiences.vue": "e44e",
	"./components/FeaturedProject": "8069",
	"./components/FeaturedProject.vue": "8069",
	"./components/FooterItem": "9644",
	"./components/FooterItem.vue": "9644",
	"./components/HeaderPartners": "630f",
	"./components/HeaderPartners.vue": "630f",
	"./components/HelloWorld": "fdab",
	"./components/HelloWorld.vue": "fdab",
	"./components/Location": "172d",
	"./components/Location.vue": "172d",
	"./components/Menu": "fb62",
	"./components/Menu.vue": "fb62",
	"./components/New": "0e47",
	"./components/New.vue": "0e47",
	"./components/Service": "1ad4",
	"./components/Service.vue": "1ad4",
	"./components/Services": "76d2",
	"./components/Services.vue": "76d2",
	"./main": "cd49",
	"./main.ts": "cd49",
	"./registerServiceWorker": "bb3e",
	"./registerServiceWorker.ts": "bb3e",
	"./router": "5f86",
	"./router.ts": "5f86",
	"./shims-tsx.d": "4aa9",
	"./shims-tsx.d.ts": "4aa9",
	"./shims-vue.d": "e154",
	"./shims-vue.d.ts": "e154",
	"./views/About": "f820",
	"./views/About.vue": "f820",
	"./views/Clustertic": "2ef1",
	"./views/Clustertic.vue": "2ef1",
	"./views/Home": "bb51",
	"./views/Home.vue": "bb51",
	"./views/Izertis": "fa99",
	"./views/Izertis.vue": "fa99",
	"./views/News": "a2f9",
	"./views/News.vue": "a2f9",
	"./views/Sadim": "7368",
	"./views/Sadim.vue": "7368",
	"./views/Simbiosys": "18ed",
	"./views/Simbiosys.vue": "18ed",
	"./views/Veratia": "4ea0",
	"./views/Veratia.vue": "4ea0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";